module.exports = __webpack_public_path__ + "static/img/right_arrow_icon.569bdb27.svg";